import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Success.css";
import Ticket from "../components/Ticket";

const Success = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loadError, setLoadError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  useEffect(() => {
    let isMounted = true;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    console.log("API_BASE_URL:", API_BASE_URL);

     
    

    const loadOrder = async () => {
      if (!orderId) {
        setLoadError("Missing order id.");
        setIsLoading(false);
        return;
      }
      try {
        setIsLoading(true);
        const response = await fetch(`${API_BASE_URL}/api/v1/public/order/${orderId}`);
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "Failed to load order");
        }
        if (isMounted) {
          setOrder(data.order || null);
          setIsLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          setLoadError(error.message || "Unable to load order.");
          setIsLoading(false);
        }
      }
    };

    loadOrder();

    return () => {
      isMounted = false;
    };
  }, [orderId]);

  if (loadError) {
    return (
      <section className="sup-experiencesection">
        <div className="sup-experi-content">
          <p className="sup-success-msg">{loadError}</p>
        </div>
      </section>
    );
  }

  if (isLoading) {
    return (
      <section className="sup-experiencesection">
        <div className="sup-experi-content">
          <div className="sup-loader">
            <span className="sup-spinner" aria-hidden="true" />
            <p className="sup-success-msg">Generating your ticket...</p>
            <p className="sup-loader-sub">Please wait, your ticket is being created.</p>
          </div>
        </div>
      </section>
    );
  }

  if (!order) {
    return (
      <section className="sup-experiencesection">
        <div className="sup-experi-content">
          <p className="sup-success-msg">Ticket not found.</p>
        </div>
      </section>
    );
  }

  return <Ticket order={order} />;
};

export default Success;
